import { memo, useContext, useState } from "react";
import { ObjectContext } from "@providers/ObjectProvider";
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import Table from '@mui/joy/Table';
import Stack from '@mui/joy/Stack';
import ObjectRelationshipCard from '@components/objects/ObjectRelationshipCard';
import { gradientTint } from "@utils/gradientTint";

const ObjectRelationshipNotes = memo(function ObjectRelationshipNotes({
  relationship,
  title,
  tint = null,
}) {
  const isEmpty = !relationship;

  return (
    <ObjectRelationshipCard
      // unpadded
      empty={isEmpty}
      title={
        <CardOverflow
          sx={theme => ({
            borderTopLeftRadius: 'calc(var(--Card-childRadius) + var(--variant-borderWidth))',
            borderTopRightRadius: 'calc(var(--Card-childRadius) + var(--variant-borderWidth))',
            marginBlockStart: 'var(--CardOverflow-offset)',
            ...gradientTint(theme, tint),
          })}
        >
          <CardActions
            sx={theme => ({
              py: 1.5,
            })}
          >
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={0.5}
            >
              <Typography sx={theme => ({flex: 1, fontWeight: '600', color: 'white' })}>{title}</Typography>
            </Stack>
          </CardActions>
        </CardOverflow>
      }
    >
      {/* <CardOverflow> */}
        {/* <CardContent> */}
        <Box fontSize={'sm'}>
          <div className="text-container" dangerouslySetInnerHTML={{__html: relationship}}></div>
        </Box>
        {/* </CardContent> */}
      {/* </CardOverflow> */}

    </ObjectRelationshipCard>
  );
});

export default ObjectRelationshipNotes;
